"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceRiskPortfolioPageSchema = exports.insuranceRiskPortfolioDetailSchema = exports.insuranceRiskPortfolioListItemSchema = exports.insuranceRiskPortfolioMemberSchema = exports.insuranceRiskPortfolioMemberQuerySchema = exports.insuranceRiskPortfolioMemberSortBySchema = exports.insuranceRiskPortfolioQuerySchema = exports.insuranceRiskPortfolioSortBySchema = exports.insuranceRiskBandSchema = exports.insuranceUnderwritingPageSchema = exports.insuranceUnderwritingDetailSchema = exports.insuranceUnderwritingListItemSchema = exports.insuranceUnderwritingVehicleSchema = exports.insuranceUnderwritingQuerySchema = exports.insuranceUnderwritingSortBySchema = exports.insuranceUnderwritingStatusSchema = exports.insuranceUnderwritingApplicantTypeSchema = exports.insuranceCompliancePageSchema = exports.insuranceComplianceDetailSchema = exports.insuranceComplianceListItemSchema = exports.insuranceComplianceQuerySchema = exports.insuranceComplianceSortBySchema = exports.insuranceComplianceStatusSchema = exports.insuranceFraudPageSchema = exports.insuranceFraudDetailSchema = exports.insuranceFraudListItemSchema = exports.insuranceFraudQuerySchema = exports.insuranceFraudSortBySchema = exports.insuranceFraudStatusSchema = exports.insuranceClaimsPageSchema = exports.insuranceClaimDetailSchema = exports.insuranceClaimListItemSchema = exports.insuranceClaimsQuerySchema = exports.insuranceClaimSortBySchema = exports.insuranceClaimStatusSchema = exports.insuranceClaimSeveritySchema = exports.insuranceCommentSchema = exports.insuranceTimelineEntrySchema = exports.insuranceVehicleSnapshotSchema = exports.insuranceDriverSnapshotSchema = exports.insuranceMutationAckSchema = exports.insuranceRecordActionInputSchema = exports.insuranceActionTypeSchema = exports.insuranceRecordCommentInputSchema = exports.insurancePageInfoSchema = exports.insuranceSortOrderSchema = void 0;
const zod_1 = require("zod");
const tickets_1 = require("./tickets");
exports.insuranceSortOrderSchema = zod_1.z.enum(["asc", "desc"]);
exports.insurancePageInfoSchema = zod_1.z
    .object({
    page: zod_1.z.number().int().positive(),
    pageSize: zod_1.z.number().int().positive(),
    totalItems: zod_1.z.number().int().nonnegative(),
    totalPages: zod_1.z.number().int().nonnegative(),
})
    .strict();
exports.insuranceRecordCommentInputSchema = zod_1.z
    .object({
    message: zod_1.z.string().trim().min(1).max(2000),
})
    .strict();
exports.insuranceActionTypeSchema = zod_1.z.enum([
    "status-update",
    "note",
    "message",
    "coaching",
    "incentive",
    "approve",
    "reject",
    "score-adjustment",
    "band-update",
    "message-all",
    "group-coaching",
]);
exports.insuranceRecordActionInputSchema = zod_1.z
    .object({
    action: exports.insuranceActionTypeSchema,
    note: zod_1.z.string().trim().max(2000).optional().nullable(),
    status: zod_1.z.string().trim().min(1).max(120).optional().nullable(),
    band: zod_1.z.string().trim().min(1).max(120).optional().nullable(),
    memberId: zod_1.z.string().trim().min(1).max(120).optional().nullable(),
    delta: zod_1.z.number().min(-100).max(100).optional().nullable(),
})
    .strict();
exports.insuranceMutationAckSchema = zod_1.z
    .object({
    ok: zod_1.z.literal(true),
})
    .strict();
exports.insuranceDriverSnapshotSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    licenseNumber: zod_1.z.string().nullable().optional(),
    email: zod_1.z.string().email().nullable().optional(),
    phone: zod_1.z.string().nullable().optional(),
    avatarInitials: zod_1.z.string(),
    avatarUrl: zod_1.z.string().url().nullable().optional(),
    driverRecordId: zod_1.z.string().nullable().optional(),
})
    .strict();
exports.insuranceVehicleSnapshotSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    label: zod_1.z.string(),
    registration: zod_1.z.string().nullable().optional(),
    icon: zod_1.z.string().nullable().optional(),
    makeModel: zod_1.z.string().nullable().optional(),
    assetType: zod_1.z.string().nullable().optional(),
    vehicleRecordId: zod_1.z.string().nullable().optional(),
})
    .strict();
exports.insuranceTimelineEntrySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    at: zod_1.z.string(),
    title: zod_1.z.string(),
    detail: zod_1.z.string().nullable().optional(),
    actorName: zod_1.z.string(),
    kind: zod_1.z.enum(["system", "status", "note", "comment", "action"]),
})
    .strict();
exports.insuranceCommentSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    author: zod_1.z.string(),
    message: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    kind: zod_1.z.enum(["comment", "action", "system"]).default("comment"),
    attachments: zod_1.z.array(tickets_1.ticketAttachmentSchema).default([]),
})
    .strict();
exports.insuranceClaimSeveritySchema = zod_1.z.enum([
    "minor",
    "major",
    "critical",
]);
exports.insuranceClaimStatusSchema = zod_1.z.enum([
    "open",
    "evidence-review",
    "assessment",
    "investigating",
    "approved",
    "settled",
    "rejected",
]);
exports.insuranceClaimSortBySchema = zod_1.z.enum([
    "reportedDate",
    "amount",
    "severity",
    "id",
]);
exports.insuranceClaimsQuerySchema = zod_1.z
    .object({
    search: zod_1.z.string().trim().optional(),
    severity: exports.insuranceClaimSeveritySchema.optional(),
    status: exports.insuranceClaimStatusSchema.optional(),
    sortBy: exports.insuranceClaimSortBySchema.default("reportedDate"),
    sortOrder: exports.insuranceSortOrderSchema.default("desc"),
    page: zod_1.z.number().int().positive().default(1),
    pageSize: zod_1.z.number().int().positive().max(100).default(6),
})
    .strict();
exports.insuranceClaimListItemSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    claimType: zod_1.z.string(),
    severity: exports.insuranceClaimSeveritySchema,
    status: exports.insuranceClaimStatusSchema,
    amount: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string().min(3).max(3),
    reportedDate: zod_1.z.string(),
    lastUpdated: zod_1.z.string(),
    assignedTo: zod_1.z.string(),
    driver: exports.insuranceDriverSnapshotSchema,
    vehicle: exports.insuranceVehicleSnapshotSchema,
})
    .strict();
exports.insuranceClaimDetailSchema = exports.insuranceClaimListItemSchema
    .extend({
    description: zod_1.z.string(),
    evidence: zod_1.z.array(zod_1.z.string()),
    timeline: zod_1.z.array(exports.insuranceTimelineEntrySchema),
    comments: zod_1.z.array(exports.insuranceCommentSchema),
})
    .strict();
exports.insuranceClaimsPageSchema = zod_1.z
    .object({
    items: zod_1.z.array(exports.insuranceClaimListItemSchema),
    pageInfo: exports.insurancePageInfoSchema,
})
    .strict();
exports.insuranceFraudStatusSchema = zod_1.z.enum([
    "investigating",
    "confirmed",
    "escalated",
    "dismissed",
    "under-review",
]);
exports.insuranceFraudSortBySchema = zod_1.z.enum([
    "detectedDate",
    "confidence",
    "title",
    "id",
]);
exports.insuranceFraudQuerySchema = zod_1.z
    .object({
    search: zod_1.z.string().trim().optional(),
    status: exports.insuranceFraudStatusSchema.optional(),
    sortBy: exports.insuranceFraudSortBySchema.default("detectedDate"),
    sortOrder: exports.insuranceSortOrderSchema.default("desc"),
    page: zod_1.z.number().int().positive().default(1),
    pageSize: zod_1.z.number().int().positive().max(100).default(6),
})
    .strict();
exports.insuranceFraudListItemSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    fraudType: zod_1.z.string(),
    confidence: zod_1.z.number().min(0).max(100),
    status: exports.insuranceFraudStatusSchema,
    detectedDate: zod_1.z.string(),
    lastUpdated: zod_1.z.string(),
    assignedTo: zod_1.z.string(),
    driver: exports.insuranceDriverSnapshotSchema,
    vehicle: exports.insuranceVehicleSnapshotSchema,
})
    .strict();
exports.insuranceFraudDetailSchema = exports.insuranceFraudListItemSchema
    .extend({
    description: zod_1.z.string(),
    evidence: zod_1.z.array(zod_1.z.string()),
    timeline: zod_1.z.array(exports.insuranceTimelineEntrySchema),
    comments: zod_1.z.array(exports.insuranceCommentSchema),
})
    .strict();
exports.insuranceFraudPageSchema = zod_1.z
    .object({
    items: zod_1.z.array(exports.insuranceFraudListItemSchema),
    pageInfo: exports.insurancePageInfoSchema,
})
    .strict();
exports.insuranceComplianceStatusSchema = zod_1.z.enum([
    "compliant",
    "under-review",
    "review-needed",
    "non-compliant",
    "remediated",
    "pending",
]);
exports.insuranceComplianceSortBySchema = zod_1.z.enum([
    "lastAudit",
    "nextAudit",
    "title",
    "status",
]);
exports.insuranceComplianceQuerySchema = zod_1.z
    .object({
    search: zod_1.z.string().trim().optional(),
    status: exports.insuranceComplianceStatusSchema.optional(),
    sortBy: exports.insuranceComplianceSortBySchema.default("lastAudit"),
    sortOrder: exports.insuranceSortOrderSchema.default("desc"),
    page: zod_1.z.number().int().positive().default(1),
    pageSize: zod_1.z.number().int().positive().max(100).default(6),
})
    .strict();
exports.insuranceComplianceListItemSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    complianceType: zod_1.z.string(),
    status: exports.insuranceComplianceStatusSchema,
    lastAudit: zod_1.z.string(),
    nextAudit: zod_1.z.string().nullable().optional(),
    assignedTo: zod_1.z.string(),
    driver: exports.insuranceDriverSnapshotSchema.nullable().optional(),
    vehicle: exports.insuranceVehicleSnapshotSchema.nullable().optional(),
})
    .strict();
exports.insuranceComplianceDetailSchema = exports.insuranceComplianceListItemSchema
    .extend({
    description: zod_1.z.string(),
    evidence: zod_1.z.array(zod_1.z.string()),
    timeline: zod_1.z.array(exports.insuranceTimelineEntrySchema),
    comments: zod_1.z.array(exports.insuranceCommentSchema),
})
    .strict();
exports.insuranceCompliancePageSchema = zod_1.z
    .object({
    items: zod_1.z.array(exports.insuranceComplianceListItemSchema),
    pageInfo: exports.insurancePageInfoSchema,
})
    .strict();
exports.insuranceUnderwritingApplicantTypeSchema = zod_1.z.enum([
    "fleet",
    "individual",
]);
exports.insuranceUnderwritingStatusSchema = zod_1.z.enum([
    "pending-review",
    "approved",
    "rejected",
    "referred",
]);
exports.insuranceUnderwritingSortBySchema = zod_1.z.enum([
    "submittedDate",
    "premium",
    "ubiScore",
    "applicant",
    "vehiclesCount",
]);
exports.insuranceUnderwritingQuerySchema = zod_1.z
    .object({
    search: zod_1.z.string().trim().optional(),
    status: exports.insuranceUnderwritingStatusSchema.optional(),
    sortBy: exports.insuranceUnderwritingSortBySchema.default("submittedDate"),
    sortOrder: exports.insuranceSortOrderSchema.default("desc"),
    page: zod_1.z.number().int().positive().default(1),
    pageSize: zod_1.z.number().int().positive().max(100).default(6),
})
    .strict();
exports.insuranceUnderwritingVehicleSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    model: zod_1.z.string(),
    year: zod_1.z.string(),
    usage: zod_1.z.string(),
    ubiScore: zod_1.z.number().min(0).max(100),
})
    .strict();
exports.insuranceUnderwritingListItemSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    applicant: zod_1.z.string(),
    applicantType: exports.insuranceUnderwritingApplicantTypeSchema,
    contactPerson: zod_1.z.string(),
    email: zod_1.z.string().email(),
    phone: zod_1.z.string(),
    vehiclesCount: zod_1.z.number().int().nonnegative(),
    ubiScore: zod_1.z.number().min(0).max(100),
    riskClass: zod_1.z.string(),
    premium: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string().min(3).max(3),
    status: exports.insuranceUnderwritingStatusSchema,
    submittedDate: zod_1.z.string(),
    lastUpdated: zod_1.z.string(),
    assignedTo: zod_1.z.string(),
})
    .strict();
exports.insuranceUnderwritingDetailSchema = exports.insuranceUnderwritingListItemSchema
    .extend({
    description: zod_1.z.string(),
    vehicleDetails: zod_1.z.array(exports.insuranceUnderwritingVehicleSchema),
    riskFactors: zod_1.z.array(zod_1.z.string()),
    recommendations: zod_1.z.array(zod_1.z.string()),
    timeline: zod_1.z.array(exports.insuranceTimelineEntrySchema),
    comments: zod_1.z.array(exports.insuranceCommentSchema),
})
    .strict();
exports.insuranceUnderwritingPageSchema = zod_1.z
    .object({
    items: zod_1.z.array(exports.insuranceUnderwritingListItemSchema),
    pageInfo: exports.insurancePageInfoSchema,
})
    .strict();
exports.insuranceRiskBandSchema = zod_1.z.enum(["low", "medium", "high"]);
exports.insuranceRiskPortfolioSortBySchema = zod_1.z.enum([
    "region",
    "avgScore",
    "driftPct",
    "exposure",
]);
exports.insuranceRiskPortfolioQuerySchema = zod_1.z
    .object({
    search: zod_1.z.string().trim().optional(),
    band: exports.insuranceRiskBandSchema.optional(),
    sortBy: exports.insuranceRiskPortfolioSortBySchema.default("region"),
    sortOrder: exports.insuranceSortOrderSchema.default("asc"),
    page: zod_1.z.number().int().positive().default(1),
    pageSize: zod_1.z.number().int().positive().max(100).default(6),
})
    .strict();
exports.insuranceRiskPortfolioMemberSortBySchema = zod_1.z.enum([
    "name",
    "score",
    "premium",
    "events",
]);
exports.insuranceRiskPortfolioMemberQuerySchema = zod_1.z
    .object({
    searchName: zod_1.z.string().trim().optional(),
    vehicleQuery: zod_1.z.string().trim().optional(),
    minScore: zod_1.z.number().min(0).max(100).default(0),
    maxScore: zod_1.z.number().min(0).max(100).default(100),
    sortBy: exports.insuranceRiskPortfolioMemberSortBySchema.default("name"),
    sortOrder: exports.insuranceSortOrderSchema.default("asc"),
    page: zod_1.z.number().int().positive().default(1),
    pageSize: zod_1.z.number().int().positive().max(100).default(5),
})
    .strict();
exports.insuranceRiskPortfolioMemberSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    driver: exports.insuranceDriverSnapshotSchema,
    vehicle: exports.insuranceVehicleSnapshotSchema,
    score: zod_1.z.number().min(0).max(100),
    premium: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string().min(3).max(3),
    eventCount: zod_1.z.number().int().nonnegative(),
})
    .strict();
exports.insuranceRiskPortfolioListItemSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    region: zod_1.z.string(),
    vehicles: zod_1.z.number().int().nonnegative(),
    avgScore: zod_1.z.number().min(0).max(100),
    band: exports.insuranceRiskBandSchema,
    driftPct: zod_1.z.number(),
    exposure: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string().min(3).max(3),
    lastUpdated: zod_1.z.string(),
    assignedTo: zod_1.z.string(),
})
    .strict();
exports.insuranceRiskPortfolioDetailSchema = exports.insuranceRiskPortfolioListItemSchema
    .extend({
    description: zod_1.z.string(),
    riskFactors: zod_1.z.array(zod_1.z.string()),
    recommendations: zod_1.z.array(zod_1.z.string()),
    timeline: zod_1.z.array(exports.insuranceTimelineEntrySchema),
    comments: zod_1.z.array(exports.insuranceCommentSchema),
    members: zod_1.z.array(exports.insuranceRiskPortfolioMemberSchema),
    membersPageInfo: exports.insurancePageInfoSchema,
})
    .strict();
exports.insuranceRiskPortfolioPageSchema = zod_1.z
    .object({
    items: zod_1.z.array(exports.insuranceRiskPortfolioListItemSchema),
    pageInfo: exports.insurancePageInfoSchema,
})
    .strict();
